<template>
  <toast-message></toast-message>
  <component :is="view" />
</template>

<script setup>
  import HomeLayout from './layouts/HomeLayout.vue'
  import AppLayout from './layouts/AppLayout.vue'
  import AdminLayout from './layouts/AdminLayout.vue'
  import ToastMessage from './components/essential/ToastMessage.vue'
  import { useToast } from '@/composables/useToast'
  import { useRoute } from 'vue-router'
  import { computed, watch } from 'vue'
  const route = useRoute()
  const { showToast } = useToast()
  watch(
    () => route.query,
    (newQuery) => {
      if (newQuery.message) {
        showToast(newQuery.message, newQuery.type || 'success')
      }
    },
    { immediate: true }
  )


  const view = computed(() => {
    switch (route.meta.layout) {
      case 'home':
        return HomeLayout
      case 'admin':
        return AdminLayout
      default:
        return AppLayout
    }
  })
</script>

<style scoped>
/* Optional: Global styles */
</style>
